import React from 'react'
import { RecordingChunkResponse } from '@app/services/auto-generated/revision'

interface LessonFeedbackContext {
  position: number
  setPosition: (position: number) => void
  audioRef: React.RefObject<HTMLAudioElement> | null
  selectedChunk: RecordingChunkResponse | null
  setSelectedChunk: (chunk: RecordingChunkResponse | null) => void
  paused: boolean
  setPaused: (paused: boolean) => void
  addChunk: (feedback: any) => void
}

const lessonFeedbackContext = React.createContext<LessonFeedbackContext>({
  position: 0,
  setPosition: () => {},
  audioRef: null,
  selectedChunk: null,
  setSelectedChunk: () => {},
  paused: true,
  setPaused: () => {},
  addChunk: () => {},
})

export default lessonFeedbackContext
